const CssData = {
  description: ["A list of all the CSS utility & modifier classes included in the core Roseworx framework import."]
}

export default CssData;